// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "import_run".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "import_run" table (1:1 with a DB row, on the wire). */
export const importRunAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    createdById: z.string().nullable(),
    kind: z.string(),
    fileName: z.string().nullable(),
    counts: z.unknown(),
    createdRecords: z.unknown(),
    wipedAt: z.string().datetime().nullable(),
    wipedById: z.string().nullable(),
    wipeSummary: z.unknown().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=importRun.js.map